/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { publicBookingPageDataMeetingLocationTypeSchema } from './PublicBookingPageDataMeetingLocationTypeSchema'
import { publicBookingPageDataStatusSchema } from './PublicBookingPageDataStatusSchema'

export const publicBookingPageDataSchema = z.object({
	status: publicBookingPageDataStatusSchema,
	companyName: z.string().nullable(),
	companyLogoUrl: z.string().nullable(),
	recruiterName: z.string().nullable(),
	jobTitle: z.string().nullable(),
	durationMinutes: z.number().nullable(),
	meetingLocationType: publicBookingPageDataMeetingLocationTypeSchema.nullable(),
	meetingLocationDetails: z.string().nullable(),
	description: z.string().nullable(),
	expiresAt: z.iso.datetime().nullable(),
	message: z.string().nullable(),
	language: z.string().nullable(),
	calendarConnectionBroken: z.boolean(),
})

export type PublicBookingPageDataSchema = z.infer<typeof publicBookingPageDataSchema>
